import axios from "axios"
import { Auth } from "../services"
import { errorList } from "./constants"
import globalRouter from "../routes/GlobalRouter"

const http = axios.create({
  baseURL: process.env.REACT_APP_API_BASEURL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
})

http.interceptors.request.use(
  (config: any) => {
    const user = Auth.getCurrentUser()
    return {
      ...config,
      headers: {
        ...(user.token !== null && { Authorization: `Bearer ${user.token}` }),
        ...config.headers,
      },
    }
  },
  (err: any) => {
    return Promise.reject(err)
  },
)

http.interceptors.response.use(
  (res: any) => {
    if (res.data.status === 401) {
      Auth.logout()
      globalRouter.navigate("/")
      return Promise.reject(res)
    } else if (
      res.data.status === 504 ||
      res.data.status === 503 ||
      res.data.status === 502 ||
      res.data.status === 500 ||
      res.data.status === 404 ||
      res.data.status === 403
    ) {
      return Promise.reject(res.data.message || errorList.get(res.data.status))
    }
    return res.data
  },
  async (err: any) => {
    if (err.response) {
      if (err.response.status === 401) {
        Auth.logout()
        globalRouter.navigate("/")
      } else if (
        err.response.status === 504 ||
        err.response.status === 503 ||
        err.response.status === 502 ||
        err.response.status === 500 ||
        err.response.status === 404 ||
        err.response.status === 403
      ) {
        return Promise.reject(
          err.response.data || { status: err.response.status, message: errorList.get(err.response.status) },
        )
      }
    }
    return Promise.reject(err.response.data)
  },
)

const getRequest = async (url: string) => {
  const res = await http.get(url)
  return res
}

const getRequestBlob = async (url: string) => {
  const res = await http
    .get(url, {
      responseType: "blob",
    })
  return res
}

const postRequest = async (url: string, payload: any) => {
  const res = await http.post(url, payload)
  return res
}

const postRequestBlob = async (url: string, payload: any) => {
  const res = await http
    .post(url, payload, {
      responseType: "blob",
    })
  return res
}

const patchRequest = async (url: string, payload: any) => {
  const res = await http.patch(url, payload)
  return res
}

const putRequest = async (url: string, payload: any) => {
  const res = await http.put(url, payload)
  return res
}

const deleteRequest = async (url: string) => {
  const res = await http.delete(url)
  return res
}

const Api = {
  http,
  getRequest,
  getRequestBlob,
  postRequest,
  postRequestBlob,
  patchRequest,
  putRequest,
  deleteRequest,
}

export default Api
